import { PropsWithChildren, ReactNode } from 'react'
import { Box, IconButton, Link, Typography } from '@material-ui/core'
import styled, { useTheme } from 'styled-components'
import { Link as RouterLink } from 'react-router-dom'

const StyledIconButton = styled(IconButton)`
  && {
    margin: 0 0 0 -0.5em;
    height: 20px;
    align-self: center;
  }
`

export interface IMainWrapperDrawerItemProps {
  linkIcon: ReactNode
  onClick?: (ev) => void
  to?: string
}

export const MainWrapperDrawerItem = ({
  onClick,
  linkIcon,
  to,
  children,
}: PropsWithChildren<IMainWrapperDrawerItemProps>) => {
  const theme = useTheme()

  return (
    <StyledIconButton size="small" onClick={onClick}>
      <Box m="0em" display="flex" flexDirection="row">
        {linkIcon}
        <Typography variant="caption" component="span">
          <Link component={RouterLink} to={to} style={{ textDecoration: 'none' }}>
            <Box color={theme.colors.accent1} m="0 1em">
              {children}
            </Box>
          </Link>
        </Typography>
      </Box>
    </StyledIconButton>
  )
}
